import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class FutureSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getFuSearch(data);
    }
}
export default FutureSearchUseCase;
